export default __webpack_public_path__ + "static/media/40_photo.9a079de5.jpg";